module.exports = __webpack_public_path__ + "open-sans-latin-800.4557e5db902605ded665.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-800.woff2
// module id = ../../../../typeface-open-sans/files/open-sans-latin-800.woff2
// module chunks = 1 3